__turbopack_context__.v({
  "emptyCard": "olWHrW_emptyCard" + " " + __turbopack_context__.i(917291)["lbRadialStroke"] + " " + __turbopack_context__.i(917291)["lbStrokeCard"] + " " + __turbopack_context__.i(917291)["lbCardBlur"] + " " + __turbopack_context__.i(917291)["lbCardBg"],
  "message": "olWHrW_message",
  "title": "olWHrW_title",
});
